<div class="charts">
  <!-- start current calls report -->
  <!-- <ng-container *ngIf="[Permissions.HomePage_CALLS_REPORT_CHART] | hasPermission">
    <app-current-calls-report-chart></app-current-calls-report-chart>
  </ng-container> -->
  <!-- end current calls report -->

  <!-- ---------------------------------------------------------------- -->

  <!-- start active teachers report -->
  <ng-container *ngIf="[Permissions.HomePage_OnLineTeacher_Chart] | hasPermission">
    <app-teachers-report-chart></app-teachers-report-chart>
  </ng-container>
  <!-- end active teachers report -->

  <!-- ---------------------------------------------------------------- -->

  <!-- start active Students report -->
  <ng-container *ngIf="[Permissions.HomePage_OnLineStudent_Chart] | hasPermission">
    <app-students-report-chart></app-students-report-chart>
  </ng-container>
  <!-- end active Students report -->

  <!-- ---------------------------------------------------------------- -->

  <!-- start app consumption chart -->
  <app-app-consumption-chart></app-app-consumption-chart>
  <!-- end app consumption chart -->
</div>
